import React, { useState } from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import AgreementContent from './AgreementContent';

export default function CasinoAgreement() {
  return (
    <CasinoContainer title={'Edit "Agreement" for'}>
      <AgreementContent />
    </CasinoContainer>
  );
}
